import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { StatusPreautorisation } from '../../../../shared/modeles/variables';
import { ToolPreautorisationService } from '../../../tool-preautorisation.service';
import { DashboardCardStatusComponent } from '../../components/dashboard-card-status/dashboard-card-status.component';
import { DebugComponent } from '../../components/debug/debug.component';
import { CancelWithConfirmation, Load, PatchDebug } from '../../state/preautorisation.actions';
import { PreautorisationSelectors } from '../../state/preautorisation.selectors';

@Injectable({
  providedIn: 'root'
})
export class PreautorisationExperimenteService extends ToolPreautorisationService {
  constructor(private readonly _store: Store) {
    super();
  }
  @Select(PreautorisationSelectors.statutPreautorisation)
  getStatusPreautorisation$: Observable<StatusPreautorisation>;

  isPreautFormInProgress$: Observable<boolean> = of(false);
  isPreautResetWithoutWarning$: Observable<boolean> = of(false);

  @Select(PreautorisationSelectors.isCoemprunteur)
  isCoemprunteur$: Observable<boolean>;

  @Select(PreautorisationSelectors.isEmprunteurSecondaire)
  isSecondCoemprunteur$: Observable<boolean>;

  getStatusAndIsLoadedPreautorisation$ = of({
    isPreautLoaded: true,
    status: null,
    currentStep: null,
    isSecondCoemprunteur: false,
    isCoemprunteur: false
  });
  preautAmount$: Observable<number> = of(0);
  isPreautExpiringSoon$: Observable<boolean> = of(false);
  lastDayBeforeExpirationPreautEnLigne$: Observable<Date> = of(null);
  isRateExpiringSoon$: Observable<boolean> = of(false);
  dateExpirationTaux$: Observable<Date> = of(null);

  @Select(state => state.preautorisationExperimente.preautorisation)
  getPreautorisation$: Observable<any>;

  readonly version = 'expérimenté';

  readonly dashboardComponent = DashboardCardStatusComponent;

  readonly debugComponent = DebugComponent;

  async initialize() {
    await this._store.dispatch(new Load()).toPromise();
  }

  debugGoToStep(step: string) {
    // Implémentation de la méthode abstraite pour étendre la classe de base
  }
  debugSetStatus(statut: string) {
    this._store.dispatch(new PatchDebug({ statut }));
  }
  initPreautorisationEnLigne() {
    // Implémentation de la méthode abstraite pour étendre la classe de base
  }
  setPreautorisation(preautorisation: any) {
    // Implémentation de la méthode abstraite pour étendre la classe de base
  }
  resetPreautorisation() {
    // Implémentation de la méthode abstraite pour étendre la classe de base
  }

  patchDebugOnly(data?: Partial<any>) {
    this._store.dispatch(new PatchDebug(data));
  }

  async annulerPreautorisation(): Promise<void> {
    // Implémentation de la méthode abstraite pour étendre la classe de base
  }

  async annulerPreautorisationAvecConfirmation(_returnUrl: string): Promise<void> {
    await this._store.dispatch(new CancelWithConfirmation()).toPromise();
  }
}
